import React, { useEffect } from 'react';
import { getUnixTime } from 'date-fns';

import { store } from 'redux/store';
import { FluxAutomaticLayoutTabs, setCurrentTab } from 'redux/reducers/fluxAutomaticLayoutReducer';
import DailyDesktop from 'components/Flux/Automatic/Daily/Desktop';
import DailyMobile from 'components/Flux/Automatic/Daily/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';

import './index.scss';

export function fluxZipFile(layoutTab: FluxAutomaticLayoutTabs) {
  return `flux-automatic-${layoutTab}-${getUnixTime(new Date())}.zip`;
}

export default function Daily() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('daily'));
  });

  if (isMobile) {
    return <DailyMobile />;
  }

  return <DailyDesktop />;
}
